import { Reveal, Eyebrow } from "./Reveal";
const FOUNDER_IMG =
    "/founder.jpg";
export const Founder = () => (
    <section id="founder" data-testid="founder-section" className="border-t border-hairline bg-paper py-24 md:py-36">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 md:px-12 lg:grid-cols-12">
            <div className="lg:col-span-6 lg:order-1 order-2">
                <Reveal>
                    <Eyebrow>Founder &amp; Principal Buyer</Eyebrow>
                    <h2 data-testid="founder-name" className="mt-6 font-display text-4xl font-light leading-tight tracking-tight md:text-5xl">
                        Alexander <em className="italic text-stone">“Sasha”</em> Koumarianos
                    </h2>
                </Reveal>
                <Reveal delay={0.1}>
                    <div className="mt-10 space-y-6 text-base leading-relaxed text-stone md:text-lg">
                        <p>
                            Sasha is a lifelong car enthusiast. An engineer by profession, he also brings many years of sales experience — which
                            means he knows exactly how the other side of the table works.
                        </p>
                        <p>
                            As founder and principal buyer, he personally handles every acquisition: finding the car, negotiating the deal and
                            making sure every detail is right before it reaches you.
                        </p>
                    </div>
                </Reveal>
                <Reveal delay={0.2}>
                    <div className="mt-12 flex flex-wrap gap-x-10 gap-y-4 border-t border-hairline pt-8 text-sm text-ink">
                        <span>Car enthusiast</span>
                        <span className="text-mist">·</span>
                        <span>Engineer</span>
                        <span className="text-mist">·</span>
                        <span>Years in sales</span>
                    </div>
                </Reveal>
            </div>
            <Reveal className="lg:col-span-4 lg:col-start-9 lg:order-2 order-1">
                <div data-testid="founder-portrait-placeholder" className="relative flex aspect-[4/5] w-full items-end bg-[#ECECEA] p-8">
                    <span className="absolute inset-0 flex items-center justify-center font-display text-8xl font-light text-[#d4d4d0]" aria-hidden>
                        AK
                    </span>
                    <img src={FOUNDER_IMG} alt="White luxury coupe parked against a minimalist white facade" data-testid="hero-image" className="relative aspect-[4/5] w-full object-cover" />

                    <div className="absolute bottom-0 left-0 h-px w-full brand-gradient" aria-hidden />
                </div>
            </Reveal>
        </div>
    </section>
);
